import { isComplete, remainingSecs } from '@/core/required-videos-time';
import type {
  RequiredVideoConfig,
  VideoProgress,
} from '@/types/required-video';

type StepArgs = {
  prev: VideoProgress;
  t: number;
  d: number;
  credit: number;
};

export function nextProgress(a: StepArgs): VideoProgress {
  return {
    ...a.prev,
    duration_secs: Math.max(a.prev.duration_secs, a.d),
    last_position: a.t,
    seconds_watched: a.prev.seconds_watched + a.credit,
  };
}

export function deriveRemaining(
  progress: VideoProgress,
  config: RequiredVideoConfig,
  completed: boolean
): number {
  if (completed) return 0;
  return remainingSecs(
    progress.seconds_watched,
    progress.duration_secs,
    config.threshold
  );
}

export function deriveCompleted(
  progress: VideoProgress,
  config: RequiredVideoConfig
): boolean {
  // Placeholder rows (video_id pending an admin update) auto-open the gate so
  // staging flows aren't content-blocked while the real video is in production.
  if (config.video_id === 'PLACEHOLDER') return true;
  if (progress.completed_at) return true;
  return isComplete(
    progress.seconds_watched,
    progress.duration_secs,
    config.threshold
  );
}
